{
  "status": {
    "draft": "Чернетка",
    "published": "Опубліковано",
    "archived": "В архіві"
  },
  "gradingMode": {
    "team": "Одна оцінка на команду",
    "individual": "Оцінка кожному учаснику"
  },
  "taskStatus": {
    "todo": "До виконання",
    "in_progress": "У роботі",
    "done": "Готово"
  },
  "submissionStatus": {
    "notStarted": "Не розпочато",
    "draft": "У роботі",
    "submitted": "Здано",
    "returned": "Повернуто на доопрацювання",
    "graded": "Оцінено"
  },
  "late": "Із запізненням",
  "list": {
    "title": "Проєкти",
    "description": "Командні проєкти, які ви ведете з класом.",
    "searchPlaceholder": "Пошук проєктів…",
    "classFilter": "Клас",
    "statusFilter": "Статус",
    "anyClass": "Будь-який клас",
    "anyStatus": "Будь-який статус",
    "table": {
      "project": "Проєкт",
      "class": "Клас",
      "team": "Команда",
      "tasks": "Картки",
      "due": "Дедлайн",
      "status": "Статус"
    },
    "team_one": "{{count}} учасник",
    "team_few": "{{count}} учасники",
    "team_many": "{{count}} учасників",
    "team_other": "{{count}} учасників",
    "noTeam": "Команди ще немає",
    "progress": "{{done}} / {{total}}",
    "noTasks": "Карток немає",
    "due": "Дедлайн {{date}}",
    "noDue": "Без дедлайну",
    "empty": {
      "title": "Проєктів ще немає",
      "text": "Створіть проєкт для класу, опишіть завдання та зберіть команду.",
      "filterText": "За цими фільтрами нічого не знайшлося."
    },
    "actions": {
      "open": "Відкрити",
      "edit": "Редагувати",
      "publish": "Опублікувати",
      "unpublish": "Повернути в чернетки",
      "duplicate": "Дублювати",
      "archive": "Архівувати",
      "more": "Інші дії для «{{title}}»"
    },
    "published": "Проєкт опубліковано",
    "unpublished": "Проєкт повернуто в чернетки",
    "duplicated": "Проєкт продубльовано",
    "archived": "Проєкт заархівовано",
    "archiveTitle": "Заархівувати «{{title}}»?",
    "archiveDescription": "Дошка застигне, а проєкт зникне з екранів команди. Картки, коментарі та оцінки залишаться."
  },
  "pupilList": {
    "title": "Мої проєкти",
    "description": "Проєкти, над якими працює ваша команда.",
    "empty": {
      "title": "Ви поки не в жодній команді проєкту",
      "text": "Коли вчитель додасть вас до команди проєкту, тут з’являться його опис, дошка та результат."
    },
    "open": "Відкрити проєкт"
  },
  "create": {
    "button": "Створити проєкт",
    "title": "Створення проєкту",
    "description": "Оберіть клас і спосіб оцінювання — опис та команду додасте далі.",
    "titleLabel": "Назва",
    "titlePlaceholder": "напр. Модель Сонячної системи",
    "classLabel": "Клас",
    "classPlaceholder": "Оберіть клас",
    "noClasses": "Активних класів немає — спершу створіть клас.",
    "dueLabel": "Дедлайн (необовʼязково)",
    "gradingModeLabel": "Оцінювання",
    "maxScoreLabel": "Максимальний бал",
    "submit": "Створити проєкт",
    "success": "Проєкт створено",
    "failed": "Не вдалося створити проєкт"
  },
  "detail": {
    "back": "До проєктів",
    "due": "Дедлайн {{date}}",
    "noDue": "Без дедлайну",
    "maxScore": "Максимум балів: {{score}}",
    "noMaxScore": "Максимальний бал не задано — оцінити результат поки неможливо.",
    "archivedNotice": "Проєкт заархівовано. Дошка застигла, а результат більше не редагується.",
    "draftNotice": "Проєкт іще в чернетках — команда його не бачить.",
    "brief": "Опис проєкту",
    "briefEmpty": "Опис порожній.",
    "editBrief": "Редагувати опис",
    "saveBrief": "Зберегти опис",
    "briefSaved": "Опис збережено",
    "briefFailed": "Не вдалося зберегти опис",
    "briefErrors": "Кілька блоків потребують уваги:",
    "cancel": "Скасувати"
  },
  "edit": {
    "title": "Налаштування проєкту",
    "titleLabel": "Назва",
    "dueLabel": "Дедлайн",
    "gradingModeLabel": "Оцінювання",
    "maxScoreLabel": "Максимальний бал",
    "save": "Зберегти",
    "saved": "Проєкт оновлено",
    "failed": "Не вдалося зберегти проєкт"
  },
  "team": {
    "title": "Команда",
    "description": "Проєкт — це його команда: лише ці учні бачать проєкт, працюють на дошці та здають результат.",
    "empty": "У команді ще нікого немає.",
    "manage": "Змінити команду",
    "dialogTitle": "Оберіть команду",
    "dialogDescription": "Позначте учнів, які працюють над проєктом. Збережений список повністю замінює команду.",
    "warning": "Якщо прибрати учасника, усі його картки на дошці лишаться без виконавця. Самі картки нікуди не зникнуть — просто проєкт зникне з екранів цього учня.",
    "noRoster": "У цьому класі ще немає зарахованих учнів.",
    "selected": "Обрано: {{count}}",
    "save": "Зберегти команду",
    "saved": "Команду оновлено",
    "failed": "Не вдалося оновити команду"
  },
  "board": {
    "title": "Дошка",
    "description": "Картки рухаються між трьома колонками; видаляти їх може лише вчитель.",
    "empty": "У цій колонці карток немає.",
    "addTask": "Додати картку",
    "frozen": "Дошка застигла, бо проєкт заархівовано.",
    "moveTo": "Перемістити до",
    "moveLabel": "Колонка для «{{title}}»",
    "assignLabel": "Виконавець для «{{title}}»",
    "unassigned": "Без виконавця",
    "moveUp": "Підняти «{{title}}»",
    "moveDown": "Опустити «{{title}}»",
    "moved": "Картку переміщено",
    "moveFailed": "Не вдалося перемістити картку — її повернуто на місце",
    "reordered": "Порядок карток змінено",
    "reorderFailed": "Не вдалося змінити порядок — його повернуто на місце",
    "deleteTask": "Видалити картку",
    "deleteTitle": "Видалити «{{title}}»?",
    "deleteDescription": "Картку та її коментарі буде видалено назавжди.",
    "deleted": "Картку видалено",
    "count_one": "{{count}} картка",
    "count_few": "{{count}} картки",
    "count_many": "{{count}} карток",
    "count_other": "{{count}} карток"
  },
  "task": {
    "createTitle": "Нова картка",
    "editTitle": "Редагування картки",
    "titleLabel": "Назва",
    "titlePlaceholder": "напр. Написати вступ",
    "descriptionLabel": "Опис",
    "statusLabel": "Колонка",
    "assigneeLabel": "Виконавець",
    "dueLabel": "Дедлайн",
    "save": "Зберегти картку",
    "created": "Картку додано",
    "saved": "Картку збережено",
    "failed": "Не вдалося зберегти картку",
    "open": "Відкрити «{{title}}»",
    "close": "Закрити",
    "noDescription": "Опису немає.",
    "detailTitle": "Картка"
  },
  "comments": {
    "title": "Коментарі",
    "empty": "Коментарів іще немає.",
    "placeholder": "Напишіть коментар…",
    "add": "Коментувати",
    "added": "Коментар додано",
    "edit": "Редагувати коментар",
    "editing": "Редагування вашого коментаря",
    "save": "Зберегти",
    "saved": "Коментар оновлено",
    "cancel": "Скасувати",
    "delete": "Видалити коментар",
    "deleteTitle": "Видалити цей коментар?",
    "deleteDescription": "Коментар буде видалено назавжди.",
    "deleted": "Коментар видалено",
    "failed": "Не вдалося зберегти коментар",
    "edited": "змінено"
  },
  "deliverable": {
    "title": "Результат",
    "description": "У команди один спільний результат — редагувати його може будь-хто з команди, доки він не зданий.",
    "notOpened": "Команда ще не почала працювати над результатом.",
    "textLabel": "Відповідь вашої команди",
    "textPlaceholder": "Опишіть, що зробила команда",
    "saveDraft": "Зберегти чернетку",
    "savedDraft": "Чернетку збережено",
    "attachments": "Вкладення",
    "addFile": "Додати файл",
    "addImage": "Додати зображення",
    "addVideo": "Додати відео",
    "addAudio": "Додати аудіо",
    "linkLabel": "Посилання (Loom, YouTube, …)",
    "linkPlaceholder": "https://…",
    "linkAdd": "Додати",
    "linkAdded": "Посилання додано",
    "uploadProgress": "Хід завантаження",
    "uploaded": "Вкладення додано",
    "removeAttachment": "Прибрати вкладення",
    "removed": "Вкладення прибрано",
    "submit": "Здати",
    "resubmit": "Здати ще раз",
    "submitTitle": "Здати результат команди?",
    "submitDescription": "Учитель побачить усе, що команда сюди додала.",
    "submitted": "Результат здано",
    "submitFailed": "Не вдалося здати результат",
    "returnedNotice": "Учитель попросив доопрацювати",
    "lockedGraded": "Результат оцінено, тому його заблоковано. Якщо команді треба щось змінити, попросіть учителя повернути роботу.",
    "feedback": "Коментар учителя",
    "score": "Оцінка {{score}} / {{max}}",
    "yourScore": "Ваша оцінка",
    "memberScores": "Оцінки учасників",
    "lateNotice": "Роботу здано після дедлайну.",
    "revisions": "Доопрацювання {{count}}"
  },
  "review": {
    "title": "Перевірка",
    "description": "Результат команди, вкладення та оцінка.",
    "nothing": "Ще нічого не здано.",
    "textAnswer": "Письмова відповідь",
    "noText": "Письмової відповіді немає.",
    "attachments": "Вкладення",
    "noAttachments": "Вкладень немає.",
    "scoreLabel": "Оцінка (максимум {{max}})",
    "feedbackLabel": "Коментар",
    "grade": "Оцінити",
    "graded": "Результат оцінено",
    "return": "Повернути на доопрацювання",
    "returned": "Повернуто команді",
    "returnNeedsFeedback": "Напишіть, що саме команді треба виправити.",
    "failed": "Не вдалося зберегти",
    "memberGrid": "Оцінки кожному учаснику",
    "memberScoreLabel": "Оцінка для {{name}}",
    "memberFeedbackLabel": "Коментар для {{name}}",
    "allMembersRequired": "Щоб оцінити, виставте бал кожному учаснику команди.",
    "noMembers": "Спершу додайте учасників команди — оцінювати поки нікого.",
    "maxScoreMissing": "Спершу задайте максимальний бал проєкту.",
    "gradedBy": "Оцінив(ла) {{name}} · {{date}}"
  },
  "classSection": {
    "title": "Проєкти",
    "empty": "Для цього класу проєктів ще немає.",
    "viewAll": "Усі проєкти"
  },
  "cards": {
    "myProjectsTitle": "Мої проєкти",
    "myProjectsDescription": "Ваші команди та найближчі дедлайни.",
    "myProjectsEmpty": "Зараз ви не входите до жодної проєктної команди.",
    "toGradeTitle": "Проєкти на оцінювання",
    "toGradeDescription": "Командні результати, які чекають на оцінку.",
    "toGradeEmpty": "Нічого не чекає.",
    "toGradeCount_one": "{{count}} результат",
    "toGradeCount_few": "{{count}} результати",
    "toGradeCount_many": "{{count}} результатів",
    "toGradeCount_other": "{{count}} результатів",
    "openQueue": "Відкрити чергу перевірки"
  },
  "queue": {
    "title": "Проєкти на оцінювання",
    "description": "Здані результати команд з ваших класів.",
    "empty": "На оцінювання нічого не чекає.",
    "open": "Перевірити"
  },
  "validation": {
    "titleRequired": "Вкажіть назву",
    "classRequired": "Оберіть клас",
    "maxScoreRequired": "Задайте максимальний бал",
    "bodyRequired": "Спершу щось напишіть",
    "scoreRequired": "Введіть оцінку"
  }
}
